<template>
  <div class="header" :id="field.FIELD_ID" :ref="field.FIELD_ID">
    <h2 class="title" :class="{ required: field.required }" v-html="field.FIELD_TITLE"
      :style="'font-size:' + font_size + ';' + field.style"></h2>
    <el-alert :title="field.DEFAULT_VALUE" type="warning" show-icon :closable="false"
      v-show="field.DEFAULT_VALUE && field.DEFAULT_VALUE !== ''">
    </el-alert>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showVal: "",
    };
  },
  props: ["field", "index", "isBaseUI", "font_size"],
  created () {
    //默认值改变，如果是字典则要转为对应中文

  },
  methods: {
    // initData: function (vals) {
    //   let newVal = ""
    //   //默认值改变，如果是字典则要转为对应中文
    //   if (vals != "" && _.isString(vals) && this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME.length) {
    //     let valueArr = vals.split(",")
    //     let spliceWord = valueArr.length > 1 ? ";" : ""
    //     valueArr.forEach(value => {
    //       let item = _.find(this.field.FIELD_DICT_NAME, { DICT_ITEM: value });
    //       newVal = newVal + (item && item.DICT_ITEM_NAME || value) + spliceWord;
    //     });
    //   } else {
    //     newVal = vals;
    //   }
    //   this.showVal = newVal
    // }
  }
};
</script>
<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: -12px;
  margin-bottom: 26px;
  padding: 0;
  height: initial !important;

  .title {
    position: relative;
    font-size: 28px;
    font-weight: bold;
    color: #232323;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    margin: 0;
    &.required::after {
      content: "*";
      margin-left: 10px;
      color: #c22115;
      font-size: 22px;
    }
    &::before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 18px;
      margin-left: -24px;
      margin-right: 10px;
      background: url("~@img/material/reassign/icon_qianzui.png") no-repeat
        center;
    }
  }
  .el-alert {
    flex-grow: 1;
    width: 10%;
    color: #ff7800;
    background-color: transparent;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/preEntry/normalTitle.vue